var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgHouse = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.53954 0.74197C7.81038 0.531322 8.18962 0.531322 8.46046 0.74197L14.4605 5.40864C14.6431 5.55073 14.75 5.76921 14.75 6.00065V13.334C14.75 13.8865 14.5305 14.4164 14.1398 14.8071C13.7491 15.1978 13.2192 15.4173 12.6667 15.4173H3.33333C2.7808 15.4173 2.25089 15.1978 1.86019 14.8071C1.46949 14.4164 1.25 13.8865 1.25 13.334V6.00065C1.25 5.76921 1.35685 5.55073 1.53954 5.40864L7.53954 0.74197ZM6.75 13.9173H9.25V8.75065H6.75V13.9173ZM10.75 13.9173V8.00065C10.75 7.58644 10.4142 7.25065 10 7.25065H6C5.58579 7.25065 5.25 7.58644 5.25 8.00065V13.9173H3.33333C3.17862 13.9173 3.03025 13.8559 2.92085 13.7465C2.81146 13.6371 2.75 13.4887 2.75 13.334V6.36746L8 2.28413L13.25 6.36746V13.334C13.25 13.4887 13.1885 13.6371 13.0791 13.7465C12.9697 13.8559 12.8214 13.9173 12.6667 13.9173H10.75Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHouse, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/house.bcad2e14.svg";
export { ForwardRef as ReactComponent };